import { readable, writable } from 'svelte/store';
import { MenuContextCustomActions } from '../MenuContextCustomActions';

export const menuContext = writable<MenuContextCustomActions>(new MenuContextCustomActions());
